import * as React from "react";
import { useState } from "react";
import { historia } from "./Data";
import "./Cards.css";
import Counter3 from "./Counter3";

export default function MediaCard() {
  const [card, setCard] = useState(-1);
  var myArray = historia;
  var rand = myArray[(Math.random() * myArray.length) | 0];

  const nextCardOnClick = () => {
    setCard((prev) => (prev + 1) % 3);
  };

  return (
    <div className="card">
      <h4 className="title">HISTORIA</h4>
      <p>{rand}</p>
      <div className="buttons">
        <Counter3 />
        <button className="btn" onClick={nextCardOnClick}>
          Następne pytanie
        </button>
      </div>
    </div>
  );
}
